module.exports = __webpack_public_path__ + "static/img/bottom_bg@3x.2b0c5cd3.png";